// Single configured Supabase client for the entire app.
//
// Why this wrapper exists:
//  - src/integrations/supabase/client.ts is auto-generated and must not be
//    edited. Any flowType / option override applied there is wiped on the
//    next regeneration.
//  - We need flowType: 'implicit' so that magic-link emails carry self-
//    contained tokens in the URL hash and resolve on any browser (PKCE
//    requires the originating browser to hold the code_verifier in
//    localStorage; cross-browser clicks silently fail and bounce to
//    /auth/signin).
//
// All app code MUST import from '@/lib/supabase'. The generated module at
// '@/integrations/supabase/client' is no longer imported anywhere in the app.
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/integrations/supabase/types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    flowType: 'implicit',
  },
});
